import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import {
  FiAlignRight,
  FiChevronDown,
  FiChevronRight,
  FiXCircle,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import mailData from "../data/mailData.js";
import "./Navbarmenu.css";
import axios from "axios";
import { lttbaseUrl } from "../Constant.js";
const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [temp,setTemp] = useState("")

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsersForContibution = [
    "aluru.akash",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "potnuru.sandeep",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "lavanya.umesh",
    "shramika.s.ambolkar",
    "lakshay.c.gupta",
    "shubham.i.tyagi"
  ];
  const AdminUsers = [
    "uma.rani.battu",
    "h.srinivasan",
    "varsha.a.tyagi",
    "jeevadharani.ramanan",
    "vanitadevi.patil",
    "ankur.e.mishra",
    "aayushi.bharti",
    "lavanya.umesh",
    "lakshay.c.gupta",
    "akash.e.tyagi",
    "aluru.akash",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "lavanya.umesh",
    "shramika.s.ambolkar",
    "lakshay.c.gupta",
    "shubham.i.tyagi",
    "potnuru.sandeep"
  ];

  const toggleClass = () => {
    setisMenu(!isMenu);
    setResponsiveclose(!isResponsiveclose);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const hide = () => setisMenu(false);

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(!isMenuSubMenu);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }

  const usersData = useSelector((state) => state.users.usersData);

  const allowedAdmins = usersData?.map((item) =>
    item.isAdmin?.toLowerCase() === "yes" ? item.EnterpriseID : null
  );

  useEffect(()=>{
    const homeUrl = async() =>{
       const result = await axios.get(`${lttbaseUrl}/homeUrl`)
        const {data:{Url}} = result
           console.log("test",Url)
      setTemp(Url)
    }
    homeUrl()
  },[])
  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    tabIndex={0}
                    className="menubar__button"
                    style={{ display: "none" }}
                    onFocus={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    tabIndex={0}
                    className="menubar__button"
                    style={{ display: "none" }}
                    onFocus={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
              <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={() => toggleClass()}
                    href={temp?temp:''}
                    target="_blank"
                  >
                    L&TT Home
                  </a>
                </li>
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    Home
                  </NavLink>
                </li>

                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  <a
                    className="nav-links"
                    href="/home#LearningOfferings"
                    activeClassName="is-active"
                    aria-expanded="false"
                    aria-haspopup="true"
                    tabindex="0"
                    onClick={hide}
                  >
                    Learning Offerings
                    <span>
                      <FiChevronDown />
                    </span>
                  </a>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li className="sub__menus__arrows2" onClick={hide}>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/API-Automation-Testing"
                      >
                        Mandatory Learning <FiChevronRight />
                      </NavLink>
                      <ul className="sub__menus22">
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            About Enbridge
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink
                            className="nav-links"
                            to="https://kxdocuments.accenture.com/contribution/5ba6f60b-51ff-491b-b96b-216fbac09a1b?referrer=https://search.accenture.com&aid=all&k=Midstream&page=1&usersessionid=2023102517291041070&usersearchid=2023102517291219646"
                            target="_blank"
                          >
                            Energy BPM Midstream Playbook
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink
                            className="nav-links"
                            to="https://kxdocuments.accenture.com/contribution/40288a97-c428-457f-81ff-e6c3f5752530?referrer=https://search.accenture.com&aid=all&k=Midstream&page=1&usersessionid=2023102517291041070&usersearchid=2023102517291219646"
                            target="_blank"
                          >
                            Energy Midstream 101
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            GenAI
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink
                            className="nav-links"
                            to="https://mylearning.accenture.com/mylearningui/learner/fulllearningpath/44cdab8b-c838-44f0-a343-2f63cf3feeba"
                            target="_blank"
                          >
                            Midstream Gas
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            Renewable Energy Overview
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="sub__menus__arrows1" onClick={hide}>
                      <NavLink
                        onClick={toggleClass}
                        //activeClassName="is-active"
                        className="nav-links"
                        to=""
                      >
                        Process-based Learning <FiChevronRight />
                      </NavLink>
                      <ul className="sub__menus21">
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            Agile Methodology
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            Change Management
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            JIRA
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            Project Management
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/SRE">
                            Site Reliability Engineering
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            ServiceNow
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="sub__menus__arrows0" onClick={hide}>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/SapMM"
                      >
                        Skill-based Learning <FiChevronRight />
                      </NavLink>
                      <ul className="sub__menus20">
                        <li onClick={toggleClass}>
                          <NavLink
                            className="nav-links"
                            to="/API-Automation-Testing"
                          >
                            API Automation Testing
                          </NavLink>
                        </li>

                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/PowerBI">
                            Power BI
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            SAP ABAP Development
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            SAP BTP
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            SAP ISU
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/SapMM">
                            SAP MM
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            SAP SD
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            ServiceNow Developer
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            TOSCA
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Comingsoon">
                            TOSCA fundamentals
                          </NavLink>
                        </li>

                        {/* <li onClick={toggleClass}>
             <NavLink className="nav-links" to="/MsPowerBI">
              
              MS Power BI
             </NavLink>
            </li> */}
                        {/* <li onClick={toggleClass}>
                                                    <NavLink className="nav-links" to="/Python">
                                                        Python
                                                    </NavLink>
                                                </li> */}
                      </ul>
                    </li>
                  </ul>
                </li>

                {/* {allowedUsersForContibution.includes(loggedInEnterpriseId) ? (
         <li className="menu-item" onClick={hide}>
          <NavLink
           activeClassName="is-active"
           className="nav-links"
           onClick={toggleClass}
           to={`/feedback`}
          >
           Feedback
          </NavLink>
         </li>
        ) : (
         ""
        )} */}
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/dashboard`}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    href={`mailto:${mailData.enbridge_talentAcademy_mail}`}
                    activeClassName="is-active"
                    className="nav-links"
                  >
                    Contact Us
                  </a>
                </li>
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/faq`}
                  >
                    FAQs
                  </NavLink>
                </li>
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/sponsors`}
                  >
                    Sponsors
                  </NavLink>
                </li>
                {/* <li className="menu-item" onClick={hide}>
                                    <NavLink
                                        activeClassName="is-active"
                                        className="nav-links"
                                        onClick={toggleClass}
                                        to={`/analytics`}
                                    >
                                        Analytics
                                    </NavLink>
                                </li> */}
                {allowedAdmins
                  .concat(AdminUsers)
                  .includes(loggedInEnterpriseId) ? (
                  <li
                    className="menu-item sub__menus__arrows"
                    onClick={toggleSubmenu}
                  >
                    <a
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={hide}
                      tabindex="0"
                      // to={`/userMaintenance`}
                    >
                      Admin
                      <FiChevronDown />
                    </a>
                    <ul className={boxClassSubMenu.join(" ")}>
                      <li className="sub__menus__arrows2" onClick={toggleClass}>
                        <NavLink className="nav-links" to="/userMaintenance">
                          User Maintenance
                        </NavLink>
                      </li>
                      <li className="sub__menus__arrows2" onClick={toggleClass}>
                        <NavLink className="nav-links" to="/newCourse">
                          Create new Skill page
                        </NavLink>
                      </li>
                      <li className="sub__menus__arrows2" onClick={toggleClass}>
                        <NavLink className="nav-links" to="/analytics">
                          Analytics
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                ) : null}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
